function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
var CircleInfo = function CircleInfo(props) {
  return React.createElement("svg", props, React.createElement("style", null, "svg", "{", "fill:#b2b6bd", "}"), React.createElement("path", {
    d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-40-176h24v-64h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
  }));
};

CircleInfo.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "1em",
  viewBox: "0 0 512 512"
};
import RadioTileGroup from './radio-tile-group';
import React from 'react';
import ReactTooltip from 'react-tooltip';

var UploadImage = /*#__PURE__*/function (_React$Component) {
  _inherits(UploadImage, _React$Component);

  var _super = _createSuper(UploadImage);

  function UploadImage(props) {
    var _this;

    _classCallCheck(this, UploadImage);

    _this = _super.call(this, props);

    _this.onImageUpload = function (event) {
      if (event.target.files && event.target.files[0]) {
        var bites = 1024;
        var mBites = 20;

        if (event.target.files[0].size <= mBites * bites * bites) {
          var inputFile = event.target.files[0];
          var reader = new FileReader();

          reader.onloadend = function () {
            _this.props.onStyleChange('background_image_url', reader.result);

            _this.props.onStyleChange('background_image_flag', 'true');

            _this.props.onStyleChange('background_image', inputFile);
          };

          reader.readAsDataURL(inputFile);
        }
      }
    };

    _this.backgroundImageTiles = [{
      identifier: 'background-image-on',
      label: I18n.t('javascript.common.on'),
      value: 'true'
    }, {
      identifier: 'background-image-off',
      label: I18n.t('javascript.common.off'),
      value: 'false'
    }];
    _this.layoutPositionTiles = [{
      identifier: 'background-image-left',
      label: '1',
      value: '1'
    }, {
      identifier: 'background-image-center',
      label: '2',
      value: '2'
    }, {
      identifier: 'background-image-right',
      label: '3',
      value: '3'
    }];
    _this.locales = {
      background_image_info: I18n.t('javascript.v2.wpf_custom_theme.styling.background_image_info'),
      layout_options_info: I18n.t('javascript.v2.wpf_custom_theme.styling.layout_options_info'),
      styling: I18n.t('javascript.v2.wpf_custom_theme.styling')
    };
    _this.avaiableFileFormats = '.png,.jpg,.jpeg';
    return _this;
  }

  _createClass(UploadImage, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement("ul", {
        className: "style-section-list"
      }, React.createElement(ReactTooltip, {
        id: "image-info-tooltip",
        className: "tooltip"
      }, React.createElement("div", null, React.createElement("div", null, this.locales.background_image_info.size), React.createElement("br", null), React.createElement("div", null, this.locales.background_image_info.format), React.createElement("div", null, this.locales.background_image_info.max_size))), React.createElement(ReactTooltip, {
        id: "layout-options-info-tooltip",
        className: "tooltip"
      }, React.createElement("div", null, React.createElement("div", null, this.locales.layout_options_info.description), React.createElement("br", null), React.createElement("div", null, this.locales.layout_options_info.position1), React.createElement("div", null, this.locales.layout_options_info.position2), React.createElement("div", null, this.locales.layout_options_info.position3), React.createElement("br", null), React.createElement("div", null, this.locales.layout_options_info.notice))), React.createElement("li", {
        className: "style-section-row"
      }, React.createElement("span", null, this.locales.styling.background_image), React.createElement(RadioTileGroup, {
        name: "wpf_custom_theme_v2[background_image_flag]",
        onChange: function onChange(backgroundImageFlag) {
          _this2.props.onStyleChange('background_image_flag', backgroundImageFlag);
        },
        selectedTile: this.props.backgroundImageFlag || this.backgroundImageTiles[0].value,
        tiles: this.backgroundImageTiles
      })), React.createElement("li", {
        className: "style-section-row"
      }, React.createElement("span", null, this.locales.styling.image), React.createElement("div", {
        className: "info-wrapper"
      }, React.createElement(CircleInfo, {
        className: "info-icon",
        "data-for": "image-info-tooltip",
        "data-tip": true
      }), React.createElement("label", {
        htmlFor: "background-image",
        className: "custom-file-upload"
      }, this.locales.styling.background_image_upload), React.createElement("input", {
        id: "background-image",
        className: "background-image",
        type: "file",
        accept: this.avaiableFileFormats,
        onChange: function onChange(event) {
          return _this2.onImageUpload(event);
        }
      }))), React.createElement("li", {
        className: "style-section-row"
      }, React.createElement("span", null, this.locales.styling.layout_options), React.createElement("div", {
        className: "info-wrapper"
      }, React.createElement(CircleInfo, {
        className: "info-icon",
        "data-for": "layout-options-info-tooltip",
        "data-tip": true
      }), React.createElement(RadioTileGroup, {
        name: "wpf_custom_theme_v2[layout_option]",
        onChange: function onChange(layoutOption) {
          _this2.props.onStyleChange('layout_option', layoutOption);
        },
        selectedTile: this.props.layoutOption || this.layoutPositionTiles[0].value,
        tiles: this.layoutPositionTiles
      }))));
    }
  }]);

  return UploadImage;
}(React.Component);

export default UploadImage;